// extracted by mini-css-extract-plugin
export default {"UneteRS":"unete_UneteRS__x9QLB"};